import { useTranslation } from '@eti/providers';
import ErrorDialog from '../../../common/error-modals/ErrorDialog';

interface TravelerDetailsPendingPaymentDialogProps {
  cancelMakeOrder: () => void;
}

const TravelerDetailsPendingPaymentDialog = ({
  cancelMakeOrder,
}: TravelerDetailsPendingPaymentDialogProps) => {
  const { t } = useTranslation();

  return (
    <ErrorDialog
      content={t('TravelerDetails.PendingPayment.Modal.ContentText')}
      isOpen
      onPrimaryAction={cancelMakeOrder}
      primaryButtonLabel={t('TravelerDetails.PendingPayment.Modal.ButtonText')}
      title={t('TravelerDetails.PendingPayment.Modal.Header')}
    />
  );
};

export default TravelerDetailsPendingPaymentDialog;
